import style from './Footer.module.scss';

export default function Footer() {
    return (
        <footer className={style.footer}>
            <div className='container'></div>
        </footer>
    );
}
